angular
	.module 'App.Repository'
	.factory 'PriceRegionRepository', ['BaseRepository', (BaseRepository) ->
		class PriceRegionRepository extends BaseRepository
			@resource = '/price_regions'
			@isRestricted = true

		return new PriceRegionRepository
	]
